<div class="main-black border-radius-bottom white-box">
	<div class="m-0 p-4">
		<nav class="navbar navbar-expand-lg border-radius-top navbar-light bg-white topnav mb-3 pt-2 pb-0 px-4 nav-border main-black">
			<ul class="navbar-nav mr-auto">
				<li class="nav-item">
					<a class="nav-link p-3 light-grey small pointer"
						[ngClass]="{'active': activeTab == tabs.siteSettings}"
						(click)="setActiveTable(tabs.siteSettings)"
					>
						<b> {{'nav.site_settings' | translate}}</b>
					</a>
				</li>
				<li class="nav-item" *ngIf="currentUser.isSCT && !isPSDevicesSite && (siteHasCharglinkDevices || siteHasBRMDevices)"> 
					<a class="nav-link p-3 light-grey small pointer"
						[ngClass]="{'active': activeTab == tabs.chargerUtilizationSettings}"
						(click)="setActiveTable(tabs.chargerUtilizationSettings)"
					>
						<b>{{'site_settings.chargers_utilization_site_settings' | translate}}</b>
					</a>
				</li>
				<li class="nav-item" *ngIf="currentUser.isSCT && (siteHasIotahDevices || siteHasStudies)">
					<a class="nav-link p-3 light-grey small pointer"
						[ngClass]="{'active': activeTab == tabs.truckUtilizationSettings}"
						(click)="setActiveTable(tabs.truckUtilizationSettings)"
					>
						<b>{{'site_utilization_settings.truck_utilization_settings' | translate}}</b>
					</a>
				</li>
				<li class="nav-item" *ngIf="currentUser.isSCT && !isPSDevicesSite && siteHasBattlinkDevices">
					<a class="nav-link p-3 light-grey small pointer"
						[ngClass]="{'active': activeTab == tabs.batteryUtilizationSettings}"
						(click)="setActiveTable(tabs.batteryUtilizationSettings)"
					>
						<b>{{'site_utilization_settings.batteries_utilization_settings' | translate}}</b>
					</a>
				</li>
				<li class="nav-item" *ngIf="usersService.hasAccessFunction('show_charglink_brm') && !isPSDevicesSite && siteHasBRMDevices">
					<a class="nav-link p-3 light-grey small pointer"
						[ngClass]="{'active': activeTab == tabs.brmSiteSettings}"
						(click)="setActiveTable(tabs.brmSiteSettings)"
					>
						<b>{{'brm_site_settings.title' | translate}}</b>
					</a>
				</li>
				<li class="nav-item" *ngIf="!isPSDevicesSite && siteHasIMDevices">
					<a class="nav-link p-3 light-grey small pointer"
						[ngClass]="{'active': activeTab == tabs.energySiteSettings}"
						(click)="setActiveTable(tabs.energySiteSettings)"
					>
						<b>{{'energy_site_settings.title' | translate}}</b>
					</a>
				</li>
			</ul>
		</nav>

		<ng-template #siteSettings>
			<app-site-settings></app-site-settings>
		</ng-template>

		<ng-template #chargerUtilizationSettings>
			<app-chargers-utilization-settings *ngIf="!isPSDevicesSite"></app-chargers-utilization-settings>
		</ng-template>

		<ng-template #truckUtilizationSettings>
			<app-truck-utilization-settings></app-truck-utilization-settings>
		</ng-template>

		<ng-template #batteryUtilizationSettings>
			<app-battery-utilization-settings *ngIf="!isPSDevicesSite"></app-battery-utilization-settings>
		</ng-template>

		<ng-template #brmSiteSettings>
			<app-brm-site-settings *ngIf="!isPSDevicesSite"></app-brm-site-settings>
		</ng-template>

		<ng-template #energySiteSettings>
			<app-energy-site-settings *ngIf="!isPSDevicesSite"></app-energy-site-settings>
		</ng-template>

		<ng-container *ngTemplateOutlet="activeTab"></ng-container>
	</div>
</div>
